"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CensorType = void 0;
var CensorType;
(function (CensorType) {
    CensorType[CensorType["Word"] = 0] = "Word";
    CensorType[CensorType["FirstChar"] = 1] = "FirstChar";
    CensorType[CensorType["FirstVowel"] = 2] = "FirstVowel";
    CensorType[CensorType["AllVowels"] = 3] = "AllVowels";
})(CensorType || (exports.CensorType = CensorType = {}));
//# sourceMappingURL=censor-type.js.map